import angular from 'angular';

export const viewsModule = angular.module(
  'portainer.nomad.react.views',
  []
).name;
